import translatePoint from './translatePoint.js';

// Higher-order function for translating a point
const translatePointBy = (x, y) => point =>
  translatePoint(point, x, y);

export default translatePointBy;